import { createSlice }       from '@reduxjs/toolkit';
import * as employeeReducers from 'Redux/Reducers/Employee';
import { Employee }          from 'Domain/Models/Employee/Employee';

export interface IEmployeeState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, Employee>,
  searchEntries: Record<string, Employee>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    searchEntries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: employeeReducers,
});
